export default __webpack_public_path__ + "static/media/tailwind.24b335b6.png";